interface IOptions {
    label: string;
    value: string;
  }


export const RemunerationTypeList: Array<IOptions> = [
    {
      label: 'High',
      value: '1',
    },
    {
      label: 'Low',
      value: '2',
    },
    {
      label: 'Average',
      value: '3',
    },
    {
      label: 'Median',
      value: '4',
    },
  ];